import * as React from 'react'
import { SVGProps } from 'react'
const SvgExclamation = (props: SVGProps<SVGSVGElement>) => (
  <svg width={2} height={10} viewBox="0 0 2 10" fill="none" {...props}>
    <path
      d="M.596 7.228.274.998V.2h1.26v.798l-.336 6.23H.596ZM.26 10V8.53h1.288V10H.26Z"
      fill="#FAF6F0"
    />
  </svg>
)
export default SvgExclamation
